import firebase from "firebase";
import { notification } from "ant-design-vue";
import {appStorage} from "@/shared/services/storage";

(async () => {
    if(firebase.messaging.isSupported()){
        const app = firebase.initializeApp({
            apiKey: "AIzaSyBaDS5jjIbOnuDKpUilZuPM-lanq0eWgrc",
            authDomain: "logistic-284913.firebaseapp.com",
            databaseURL: "https://logistic-284913.firebaseio.com",
            projectId: "logistic-284913",
            storageBucket: "logistic-284913.appspot.com",
            messagingSenderId: "770295838299",
            appId: "1:770295838299:web:13df3d6421369455f6f17e",
            measurementId: "G-PB8QDQRS94"
        });
        const messaging = app.messaging()

        messaging.onMessage((payload) => {
            console.log(payload)

            return notification.info({
                message:`${payload.data["name"]}`,
                description:`${payload.data['message']}`
            })

        })
        const token = await messaging.getToken();
        appStorage.set('devicetoken', token);
        console.log(token);
    }
})()
